<template>
  <el-autocomplete :value="value"
                   ref="searchTips"
                   v-bind="$attrs"
                   :fetch-suggestions="handleChange"
                   popper-class="kye-popper-auto"
                   :placeholder="placeholder"
                   :trigger-on-focus="false"
                   style="width:100%"
                   @input="handleInput"
                   @focus="handleFocus"
                   @blur="handleBlur"
                   @select="handleSelect"
                   @mouseenter.native="isFocus = true"
                   @mouseleave.native="isFocus = false">
    <!-- <i slot="prefix"
       class="el-input__icon el-icon-search"></i> -->
    <i slot="suffix"
       v-if="showClear"
       class="el-input__icon el-icon-circle-close search-tips-clear"
       @mousedown.prevent
       @click="clear"></i>
    <template slot-scope="props">
      <p :class="{'kye-search-tips__option': props.item.optionDisabled}">
        <span v-for="(k, i) in getKeys" :key="k">
          {{props.item[k]}}
          <span v-if="i < getKeys.length -1">，</span>
        </span>
      </p>
    </template>
  </el-autocomplete>
</template>

<script>
  import { isFunction } from 'lodash'
  const hrEmployeeApis = [
    'hr.employee.refactoring.searchByNameOrNumber',
    'hr.employee.refactoring.listExSensitive',
    'hr.employee.refactoring.list'
  ]
  const dataEmployeeApis = [
    'data.employee.listByNameFilterMobile',
    'data.employee.listByName'
  ]

  const newkeys = {
    hr: ['name', 'duty', 'department', 'employeeNumber'],
    data: ['chineseName', 'position', 'departmentName', 'employeeNumber']
  }

  const oldkeys = {
    hr: ['name', 'employeeNumber', 'duty'],
    data: ['chineseName', 'employeeNumber', 'position']
  }
  const getEmployeeKeys = (keys, type) => {
    if (!keys) {
      return newkeys[type]
    }
    if (JSON.stringify(keys) === JSON.stringify(oldkeys[type])) {
      return newkeys[type]
    }
    return keys
  }

  export default {
    name: 'kye-search-tips',
    props: {
      value: {
        type: String
      },
      url: {
        type: String,
      },
      axios: {
        type: [String, Object]
      },
      inputLength: {
        type: Number,
        default: 2
      },
      keys: {
        type: Array
      },
      valueKey: {
        type: String,
      },
      formatData: {
        type: Function,
      },
      placeholder: {
        type: String
      },
      warning: {
        type: Boolean,
        default: true
      },
      clearable: {
        type: Boolean,
        default: false
      },
      formatResult: {
        type: Function
      },
      message: {
        type: String,
        default: '搜索结果为空！'
      },
      user: {
        type: Boolean,
        default: false
      },
      options: [Function, Array]
    },
    data () {
      return {
        isFocus: false,
        currentValue: ''
      }
    },
    computed: {
      placeholderText () {
        return `字数不少于${this.inputLength}`
      },
      val () {
        return this.value || this.currentValue
      },
      showClear () {
        return this.value && this.clearable && !this.$attrs.disabled && this.isFocus
      },
      getKeys () {
        if (hrEmployeeApis.includes(this.url)) {
          return getEmployeeKeys(this.keys, 'hr')
        }
        if (dataEmployeeApis.includes(this.url)) {
          return getEmployeeKeys(this.keys, 'data')
        }
        return this.keys
      }
    },
    methods: {
      errorReport (err) {
        this.$logReport({
          menuId: '2820215716730110', // 菜单id
          logId: 'public-search-tips', // 日志id 建议：部门标识 + 编码，方便识别
          log: JSON.stringify(err.message + err.stack) // 日志详情
        })
      },
      actionReport (msg) {
        const user = window.__ERPUSER__ || {}
        if (user && user.employeeNumber && user.employeeNumber === '000888') {
          this.$logReport({
           menuId: '2820215716730110', // 菜单id
           logId: 'public-search-tips-boss', // 日志id 建议：部门标识 + 编码，方便识别
           log: msg // 日志详情
          })
        }
      },
      handleInput (val) {
        if (val) {
          val = val.trim()
        }
        this.currentValue = val
        if (val === '') {
          this.$emit('clear')
          this.cacheData = null
          this.$refs.searchTips.suggestions = []
        }
        this.$parent.clearValidate && this.$parent.clearValidate()
        this.$emit('searchInput', val)
      },
      focus () {
        this.$refs.searchTips.focus()
      },
      // 自动选择第一行
      setHighlight (data) {
        this.$nextTick(_ => {
          let searchTipsRef = this.$refs.searchTips
          if (!searchTipsRef || !data.length) return
          searchTipsRef.highlight && searchTipsRef.highlight(0)
        })
      },
      handleChange (val, cb) {
        const isCache = !this.cacheData ? 'nocache' : 'cache'
        this.actionReport(val + ',' + isCache)
        if (this.cacheData && (this.user || hrEmployeeApis.includes(this.url) || dataEmployeeApis.includes(this.url))) {
          // 有调用接口获取数据，并且搜索字段后有空格
          if (val && /\S+\s+/.test(val)) {
            let value = val.trim().replace(/\s+/, ' ')
            let arr = value.split(' ')
            if (!arr[0] || arr[0].length < this.inputLength) {
              this.$refs.searchTips.loading = false
              return
            }
            if (arr[1] && this.cacheData && this.cacheData.length > 0) {
              let data = this.cacheData.filter(item => this.getKeys.some(k => item[k].includes(arr[1])))
              cb(data)
              this.setHighlight(data)
            } else if (!arr[1] && this.cacheData && this.cacheData.length > 0) {
              cb(this.cacheData)
              this.setHighlight(this.cacheData)
            }
          } else {
            if (val) {
              val = val.trim()
            }
            if (!val || val.length < this.inputLength) {
              this.$refs.searchTips.loading = false
              return
            }
            this.fetchData(val, cb)
          }
        } else {
          if (val) {
            val = val.trim()
          }
          if (!val || val.length < this.inputLength) {
            this.$refs.searchTips.loading = false
            return
          }
          if (this.$props.options) {
            this.usePropsOptions(val, cb)
          } else {
            this.fetchData(val, cb)
          }
        }
      },
      async usePropsOptions (val, cb) {
        try {
          let data = []
          if (isFunction(this.$props.options)) {
            data = await this.$props.options(val)
          } else if (Array.isArray(this.$props.options)) {
            data = this.$props.options
          }
          if (data.length) {
            this.cacheData = data
            cb(data)
            // 自动选择第一行
            this.setHighlight(data)
          } else {
            this.cacheData = null
            this.$emit('input', this.currentValue)
            setTimeout(_ => {
              this.$refs.searchTips.suggestions = []
              this.$emit('select', null)
            })
            setTimeout(_ => {
              this.$refs.searchTips.loading = false
              if (this.message !== '') {
                this.$message.warning({
                  duration: 1000,
                  message: this.message
                })
              }
            }, 500)
          }
        } catch (err) {
          setTimeout(_ => {
            this.errorReport(err)
            this.cacheData = null
            const noop = []
            cb(noop)
            this.$refs.searchTips.loading = false
          }, 500)
        }
      },
      async fetchData (val, cb) {
        try {
          let url = this.url === 'data.department.listByNames' ? 'hr.department.getByFuzzyValue' : this.url
          let params = this.url === 'data.department.listByNames' ? { fuzzyValue: this.formatData(val).departmentNames[0] } : this.formatData(val)
          let res = await this.$http(url, params, this.axios)
          if (this.formatResult) {
            res = this.formatResult(res)
          }
          let data = res.rows || res
          if (hrEmployeeApis.includes(url)) {
            data = [
              ...data.filter(it => it.inOffice === 10).map(it => Object.assign(it, {optionDisabled: false})),
              ...data.filter(it => it.inOffice === 20).map(it => Object.assign(it, {optionDisabled: true}))
            ]
          } else if (dataEmployeeApis.includes(url)) {
            data = [
              ...data.filter(it => it.status === '10').map(it => Object.assign(it, {optionDisabled: false})),
              ...data.filter(it => it.status === '20').map(it => Object.assign(it, {optionDisabled: true}))
            ]
          }
          if (data.length) {
            this.cacheData = data
            cb(data)
            // 自动选择第一行
            this.setHighlight(data)
          } else {
            this.cacheData = null
            this.$emit('input', this.currentValue)
            setTimeout(_ => {
              this.$refs.searchTips.suggestions = []
              this.$emit('select', null)
            })
            setTimeout(_ => {
              this.$refs.searchTips.loading = false
              if (this.message !== '') {
                this.$message.warning({
                  duration: 1000,
                  message: this.message
                })
              }
            }, 500)
          }
        } catch (err) {
          setTimeout(_ => {
            this.errorReport(err)
            this.cacheData = null
            const noop = []
            cb(noop)
            this.$refs.searchTips.loading = false
          }, 500)
        }
      },
      handleSelect (val) {
        this.$emit('input', val[this.valueKey])
        this.$emit('select', val)
      },
      handleBlur (e) {
        this.isFocus = false
        if (this.warning) {
          if (this.currentValue && this.currentValue.length < this.inputLength) {
            this.$message.warning(this.placeholderText)
          }
        }
        this.$refs.searchTips.loading = false
        setTimeout(_ => {
          this.$parent.clearValidate && this.$parent.clearValidate()
          // 2023-01-05 输入的文本如果复制过来的，且文本中如果包含空格，cacheData 缓存数据存在的情况下，会默认走本地搜索，导致复制文本无法调用接口搜索
          this.cacheData = null
          this.$emit('blur')
        })
        setTimeout(_ => {
          if (this.value !== this.currentValue) {
            this.$refs.searchTips.$refs.input.currentValue = this.value
            this.$refs.searchTips.suggestions = []
          }
          this.$parent.onFieldBlur && this.$parent.onFieldBlur()
        }, 300)
      },
      clear () {
        this.$emit('clear')
        this.$refs.searchTips.suggestions = []
        setTimeout(_ => {
          this.$parent.onFieldBlur && this.$parent.onFieldBlur()
        }, 300)
      },
      handleFocus () {
        this.isFocus = true
        this.$emit('focus')
      }
    }
  }
</script>

<style lang="scss">
  .kye-popper-auto {
    width: auto !important;
    .kye-search-tips__option {
      color: #ccc;
      &:hover {
        color: #ccc;
      }
    }
  }
  .search-tips-clear {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-search-tips/index.vue